import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bbcf504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-page" }
const _hoisted_2 = { class: "password-page__form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "password-page__title" }, "Set new password", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password-page__desc" }, "You will receive an e-mail with password reset link", -1))
const _hoisted_5 = { class: "password-page__form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mail", -1))
const _hoisted_7 = { class: "password-page__form-buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "password-page__title" }, "E-mail sent!", -1))
const _hoisted_9 = { class: "password-page__back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.emailSent)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "button button--big button--green",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)), ["prevent"]))
                }, "Reset Password")
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.emailSent)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "button button--big button--green",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)), ["prevent"]))
              }, "Back to login")
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}